export default "__VITE_ASSET__s1Jy02hh__"